import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Helpers
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';

class Article extends Component {
  static getMarkup(articleContent) {
    return { __html: articleContent };
  }

  // To form faq link for by FAQ id of solutionLink in the content
  static handleFAQClick(event) {
    const clickTarget = event.target;
    const id = clickTarget.id;

    // To check the click content is solutionLink
    if (id && clickTarget.name === 'solutionLink') {
      event.preventDefault();
      const target = clickTarget.target || '_self';
      // TODO: add article title into the getArticleLink function
      window.open(Page.getArticleLink(id), target);
    }
  }

  static handleKeyPress(event) {
    if (event.which === 13) {
      Article.handleFAQClick();
    }
  }

  constructor(props) {
    super(props);
    this.contentElement = null;
  }

  componentDidMount() {
    setTimeout(() => {
      // Link click Tracking in Article Component
      const contentLinks = this.contentElement.querySelectorAll('a[href]');
      Array.from(contentLinks).forEach((link) => {
        link.addEventListener('click', e => this.handleLinkClick(e, link));
      });
    });
  }

  // Remove img replacement to div due to icon breakline issue
  componentDidUpdate() {
    // Adding setTimeout on top as tag element is not picked immediately safari and IE versions
    setTimeout(() => {
      if (!this.contentElement) {
        return;
      }

      let imageTags = this.contentElement.getElementsByTagName('img');
      imageTags = Array.prototype.slice.call(imageTags);
      imageTags.forEach((tag) => {
        const divEl = document.createElement('img');
        divEl.setAttribute('src', tag.src);
        divEl.style.height = `${tag.height}px`;
        divEl.style.maxWidth = `${tag.width}px`;
        divEl.setAttribute('alt', tag.alt);
        divEl.className = 'okm-image';
        tag.parentNode.replaceChild(divEl, tag);
      });

      // rewarp Youtube video content
      let iframeTags = this.contentElement.getElementsByTagName('iframe');
      iframeTags = Array.prototype.slice.call(iframeTags);
      iframeTags.forEach((tag) => {
        const videoEl = tag;
        videoEl.className = 'okm-paypal-iframe';
        videoEl.setAttribute('src', tag.src && tag.src.replace('youtube.com', 'youtube-nocookie.com'));
        // TODO: Enable Youtube Video for Contextual Help
        tag.parentNode.removeChild(tag);
      });
    });
  }

  handleLinkClick(e, link) {
    const articleId = this.props.article.articleId;
    const href = link.getAttribute('href');

    if (!href) {
      e.preventDefault();
      trackLink({ id: this.props.pageName, link: `smarthelp-related-article|${articleId}|broken-link-clicked` });
    } else {
      trackLink({ id: this.props.pageName, link: `smarthelp-related-article|${articleId}|link-clicked|${href}` });
      if (Page.isAnchorLink(href) && !Page.isMPPEnable()) {
        setTimeout(() => Page.scrollDown(), 20);
      }
    }
  }

  render() {
    const { article } = this.props;
    const articleContent = article && article.articleContent;
    const articleTitle = article && article.articleTitle;
    const tabAttribs = {
      className: this.props.className,
      role: 'tabpanel',
      tabIndex: '0',
      'aria-selected': true,
    };

    return (
      <div {...tabAttribs}>
        <p className="title">
          {articleTitle}
        </p>
        <div className="contents" role="article">
          <p // eslint-disable-line jsx-a11y/no-static-element-interactions
            className="okm-content"
            dangerouslySetInnerHTML={Article.getMarkup(articleContent)} // eslint-disable-line react/no-danger
            ref={(el) => { this.contentElement = el; }}
            onClick={Article.handleFAQClick}
            onKeyPress={Article.handleKeyPress}
          />
        </div>
      </div>
    );
  }
}

Article.defaultProps = {
  article: undefined,
  className: 'article-component',
  pageName: 'contactUsPage',
};

Article.propTypes = {
  article: PropTypes.shape({
    articleId: PropTypes.string,
    articleTitle: PropTypes.string,
    topicId: PropTypes.string,
    articleContent: PropTypes.string,
  }),
  className: PropTypes.string,
  pageName: PropTypes.string,
};

export default Article;
